function equalizeGridRedesign() {
    if($(window).width() >= 491) {

        $('section').each(function() {
            var maxHeight = 0;
            var maxHeadlineHeight = 0;
            $(this).find('.equalize').each(function() {
                $(this).find('.ce-bodytext').each(function() {
                    height = $(this).outerHeight();
                    if(height > maxHeight) {
                        maxHeight = height;
                    }
                });
                $(this).find('div.frame > div .headline').each(function() {
                    headlineHeight = $(this).outerHeight();
                    if(headlineHeight > maxHeadlineHeight) {
                        maxHeadlineHeight = headlineHeight;
                    }
                });
            });
            if( ($(this).find('.equalize').length > 0 || $(this).find('.frame.grid-3cols').length > 0) && maxHeight > 0) {
                $(this).find('.equalize .ce-bodytext').css('min-height', maxHeight+90);// +50 für den absolute positionierten button
            }
            if(($(this).find('.equalize').length > 0 || $(this).find('.frame.grid-3cols').length > 0) && maxHeadlineHeight > 0) {
                $(this).find('.equalize div.frame > div div.headline').css('min-height', maxHeadlineHeight);
            }
        });
    }
}

jQuery(window).load(function () {
    equalizeGridRedesign();
});
jQuery(window).resize(function () {
    $('.equalize .ce-bodytext, .equalize div.frame > div div.headline').css('min-height', '');
    equalizeGridRedesign();
});
